import { createFileRoute } from '@tanstack/react-router'
import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'

/**
 * SUPER_ADMIN cross-org notification monitor (#1284 part 2). Gated to
 * SUPER_ADMIN only — non-SUPER_ADMINs are redirected to /unauthorized and the
 * backend endpoint enforces the same.
 */
export const Route = createFileRoute(
  '/_authenticated/org/$orgId/notifications/all'
)({
  beforeLoad() {
    requiredRoles([UserRole.SUPER_ADMIN])
  },
})
